import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import "../style/ContactForm.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import toast, { Toaster } from "react-hot-toast";

const ContactForm = () => {
  const initialValues = {
    firstName: "",
    lastName: "",
    age: "",
    email: "",
    description: "",
    recaptcha: "",
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    age: Yup.number()
      .typeError("Age must be a number")
      .positive("Age must be a positive number")
      .integer("Age must be a whole number")
      .required("Age is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    recaptcha: Yup.string().required("Please verify that you are not a robot"),
  });

  const onSubmit = (values, { setSubmitting, resetForm }) => {
    setTimeout(() => {
      alert(JSON.stringify(values, null, 2));
      resetForm();
      setSubmitting(false);
    }, 400);
  };

  return (
    <>
      <div className="form-container">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting, setFieldValue }) => (
            <Form>
              <div className="form-field">
                <label htmlFor="firstName">First Name</label>
                <Field type="text" name="firstName" />
                <ErrorMessage
                  name="firstName"
                  component="div"
                  className="error"
                />
              </div>
              <div className="form-field">
                <label htmlFor="lastName">Last Name</label>
                <Field type="text" name="lastName" />
                <ErrorMessage
                  name="lastName"
                  component="div"
                  className="error"
                />
              </div>
              <div className="form-field">
                <label htmlFor="age">Age</label>
                <Field type="number" name="age" />
                <ErrorMessage name="age" component="div" className="error" />
              </div>
              <div className="form-field">
                <label htmlFor="email">Email</label>
                <Field type="email" name="email" />
                <ErrorMessage name="email" component="div" className="error" />
              </div>
              <div className="form-field">
                <label htmlFor="description">Description</label>
                <Field name="description" as="textarea" />
                <ErrorMessage
                  name="description"
                  component="div"
                  className="error"
                />
              </div>
              <div className="form-field">
                <label>Are you human?</label>
                <ReCAPTCHA
                  sitekey="6LfCYRolAAAAAPFOnPDCYK2Mxcfhr0rHYZrN5pbB"
                  onChange={(value) => {
                    setFieldValue("recaptcha", value);
                  }}
                />
                <ErrorMessage
                  name="recaptcha"
                  component="div"
                  className="error"
                />
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="submit-btn"
                onClick={() => toast.success("Great")}
              >
                Submit
              </button>
              <Toaster />
            </Form>
          )}
        </Formik>
      </div>

      {/*-----------Start of Footer----------- */}
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p>&copy; 2023 Roland Ajeti. All Rights Reserved.</p>
            </div>
            <div className="col-md-6">
              <ul className="footer-links">
                <li>
                  <a href="home" className="anchor">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="home" className="anchor">
                    Terms of Use
                  </a>
                </li>
                <li>
                  <a href="home" className="anchor">
                    Contact Us
                  </a>
                </li>
              </ul>
              <ul className="social-icons">
                <li>
                  <a
                    href="https://www.instagram.com/rolandajeti/"
                    aria-label="Take a look at my Instagram Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "instagram"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/roland-ajeti-834335207/"
                    aria-label="Take a look at my LinkedIn Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "linkedin"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCA7Tj3B9h2FikEHcEJI4cnQ"
                    aria-label="Take a look at my Youtube Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "youtube"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/RolandAjeti"
                    target={"_blank"}
                    rel="noreferrer"
                    aria-label="Take a look at my Twitter Profile"
                  >
                    <FontAwesomeIcon icon={["fab", "twitter"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://rolandajeti-portfolio-website.netlify.app/"
                    aria-label="Take a look at my Portfolio Website"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faBriefcase} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/*-----------End of Footer----------- */}
    </>
  );
};

export default ContactForm;
